import { DesktopDatePicker } from "@mui/lab";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import moment from "moment";
import React, { useState } from "react";
import { useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../../../../components/services/api";
import { makeStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import { SUM_FREETIME } from "../../components/sum";
import mime from "mime";
import { saveAs } from "file-saver";

const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function Transportion() {
  const history = useHistory();
  const { id } = useParams();
  const classes = useStyles();
  const [loadingBC, setLoadingBC] = useState(false);
  const [remarkType, setremarkType] = useState("");

  const [voyIn, setVoyIn] = useState([]);
  const [voyOut, setVoyOut] = useState([]);
  const [openVoyIn, setOpenVoyIn] = useState(false);
  const [openVoyOut, setOpenVoyOut] = useState(false);
  const [numberOfTrucks, setNumberOfTrucks] = useState("");

  const [diremark, setDiremark] = useState(false);
  const [remarklog, setremarkLog] = useState("");
  const [transportationData, setTransportationData] = useState(null);
  const [groupData, setGroupData] = useState([]);
  const [depotsData, setDepotsData] = useState([]);
  const [factoryData, setFactoryData] = useState([]);
  const [locationData, setLocationData] = useState([]);

  const [selectDialog, setSelectedDialog] = useState();
  const [isEdit, setIsEdit] = useState({ status: false, id: null });
  const [rowMTCACS, setRowMTCACS] = useState([]);
  const [rowStuffing, setRowStuffing] = useState([]);
  const [addTruck, setAddTruck] = useState(null);
  const [addVender, setAddVender] = useState(null);
  const [editTruck, setEditTruck] = useState(null);
  const [editNumberOfTrucks, setEditNumberOfTrucks] = useState(null);
  const [editVender, setEditVender] = useState(null);
  const [addPUD, setAddPUD] = useState(null);
  const [addFactory, setAddFactory] = useState(null);
  const [addRD, setAddRD] = useState(null);
  const [addRS, setAddRs] = useState(null);
  const [isEditS, setIsEditS] = useState({ status: false, id: null });
  const [editPUD, setEditPUD] = useState(null);
  const [editFactory, setEditFactory] = useState(null);
  const [editRD, setEditRD] = useState(null);
  const [editRS, setEditRS] = useState(null);
  const [companyData, setCompanyData] = useState([]);
  const [venderData, setVenderData] = useState([]);
  const [inspectionStationData, setInspectionStationData] = useState([]);
  const [terminalData, setTerminalData] = useState([]);

  const handleCloseremark = () => {
    setDiremark(false);
    setremarkType("");
    setremarkLog("");
  };
  useEffect(() => {
    const getTransportation = async () => {
      const res = await api.get(`api/saleorder/detail/transportation/${id}`);
      const data = await res.data;
      if (res.meta.status === true) {
        setTransportationData(data);
        setRowMTCACS(
          data.MtCntr.map((x, i) => ({
            id: data.MtCntr.slice(-1)[0]?.id
              ? data.MtCntr.slice(-1)[0]?.id + 1
              : i + 1,
            Truck: x.TruckRequest,
            ...x,
          }))
        );
        if (factoryData.length > 0) {
          setRowStuffing(
            data.StuffingPlan.map((x, i) => ({
              id: data.StuffingPlan.slice(-1)[0]?.id
                ? data.StuffingPlan.slice(-1)[0]?.id + 1
                : i + 1,
              Factory: factoryData?.filter(
                (y) => x.FactoryId === y?.FactoryId
              )[0],
              PUD: x.PickupDate,
              RD: x.ReturnDate,
              RS: x.Quantity,
            }))
          );
        }
      }
    };
    getTransportation();
  }, [factoryData, id]);

  const getMasterGroup = async () => {
    const res = await api.get(`api/master/group`);
    const data = await res.data;
    if (res.meta.status === true) {
      setGroupData(data.data);
    }
  };
  const getMasterTerminal = async () => {
    const res = await api.get(`api/terminal/list`);
    const data = await res.data;
    setTerminalData(data);
  };
  const getDepots = async () => {
    try {
      const res = await api.get("api/depots/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setDepotsData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getFactoryList = async () => {
    try {
      const res = await api.get("api/factory/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setFactoryData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getLocation = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setLocationData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getCompanyList = async () => {
    try {
      const res = await api.get("api/company/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setCompanyData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getVenderList = async () => {
    try {
      const res = await api.get("api/vender/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setVenderData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getInspectionStation = async () => {
    try {
      const res = await api.get("api/inspectionStation/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setInspectionStationData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getMasterGroup();
    getDepots();
    getFactoryList();
    getLocation();
    getCompanyList();
    getInspectionStation();
    getVenderList();
    getMasterTerminal();
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}></Grid>
      {transportationData ? (
        <Formik
          enableReinitialize
          initialValues={{
            TripType: transportationData?.TripType || "Round Trip",
            TripDirection: transportationData?.TripDirection || "",
            ServiceType: transportationData?.ServiceType || "",
            det: transportationData?.det,
            dem: transportationData?.dem,
            com: transportationData?.com,
            CountingType: transportationData?.CountingType,
            container_require_select: transportationData?.ContainerStockType,
            grade: transportationData?.ContainerGrade,
            apply_layer_plastic_sheet:
              transportationData?.ContainerApplyPlasticSheet,
            first_pickup: transportationData?.FirstPickupDate,
            actual_pickup: transportationData?.ActualPickupDate,
            depots:
              depotsData?.length > 0
                ? depotsData?.find(
                    (x) => x?.DepotsId === transportationData?.DepotsId
                  )
                : null,
            transport_InBound: transportationData?.InboundTransportGroupId,
            InBoundGateOut:
              locationData.length > 0
                ? locationData?.find(
                    (x) =>
                      x?.LocationId === transportationData?.InboundGateOutId
                  )
                : null,
            container_gender_Inbound:
              transportationData?.InboundContainerGender ||
              (transportationData?.TripType === "One-Way" &&
              transportationData?.TripDirection === "Import"
                ? "Laden"
                : ""),
            transport_OutBound: transportationData?.OutboundTransportGroupId,
            OutBoundGateOut:
              locationData.length > 0
                ? locationData?.find(
                    (x) =>
                      x?.LocationId === transportationData?.OutboundGateOutId
                  )
                : null,
            container_gender_OutBound:
              transportationData?.OutboundContainerGender ||
              (transportationData?.TripType === "One-Way" &&
              transportationData?.TripDirection === "Export"
                ? "Laden"
                : ""),
            voyIn: transportationData?.InboundVoyNo,
            ETD_Gate_Out_Inbound: transportationData?.InboundETDGateOut,
            ETA_Gate_In_Inbound: transportationData?.InboundETAGateIn,
            InboundQuantity: transportationData?.InboundQuantity,
            voyIn_2: transportationData?.InboundVoyNo_2,
            ETD_Gate_Out_Inbound_2: transportationData?.InboundETDGateOut_2,
            ETA_Gate_In_Inbound_2: transportationData?.InboundETAGateIn_2,
            InboundQuantity_2: transportationData?.InboundQuantity_2,
            voyIn_3: transportationData?.InboundVoyNo_3,
            ETD_Gate_Out_Inbound_3: transportationData?.InboundETDGateOut_3,
            ETA_Gate_In_Inbound_3: transportationData?.InboundETAGateIn_3,
            InboundQuantity_3: transportationData?.InboundQuantity_3,
            first_Laden_Date: transportationData?.FirstLadenDate,
            actual_Laden_Date: transportationData?.ActualLadenDate,
            voyOut: transportationData?.OutboundVoyNo,
            ETD_Gate_Out_OutBound: transportationData?.OutboundETDGateOut,
            ETA_Gate_In_OutBound: transportationData?.OutboundETAGateIn,
            OutboundQuantity: transportationData?.OutboundQuantity,
            voyOut_2: transportationData?.OutboundVoyNo_2,
            ETD_Gate_Out_OutBound_2: transportationData?.OutboundETDGateOut_2,
            ETA_Gate_In_OutBound_2: transportationData?.OutboundETAGateIn_2,
            OutboundQuantity_2: transportationData?.OutboundQuantity_2,
            voyOut_3: transportationData?.OutboundVoyNo_3,
            ETD_Gate_Out_OutBound_3: transportationData?.OutboundETDGateOut_3,
            ETA_Gate_In_OutBound_3: transportationData?.OutboundETAGateIn_3,
            OutboundQuantity_3: transportationData?.OutboundQuantity_3,
            phyto_cert: transportationData?.PhytoCert,
            fumigation: transportationData?.Fumigation,
            phyto_cert_remark: transportationData?.PhytoCertRemark,
            fumigation_remark: transportationData?.FumigationRemark,
            volume_container: transportationData?.ContainerTypeId,
            volume_quantity: transportationData?.Quantity,
            commodity: transportationData?.CommodityId
              ? transportationData?.CommodityId
              : "",
            PhytoCertInspectionStaionId:
              transportationData?.PhytoCertInspectionStaionId,
            FumigationInspectionStaionId:
              transportationData?.FumigationInspectionStaionId,
            FumigationPQNo: transportationData?.FumigationPQNo,
            Delivery: transportationData?.Delivery,
            TerminalName: transportationData?.TerminalName
              ? { TerminalName: transportationData?.TerminalName }
              : null,
          }}
          onSubmit={(values, { setSubmitting }) => {
            // console.log(values)
            const body = {
              SaleOrderId: id,
              TripType: values.TripType || "Round Trip",
              TripDirection: values.TripDirection || null,
              ServiceType: values.ServiceType || null,
              DET: values.det,
              DEM: values.dem,
              COM: values.com,
              CountingType: values.CountingType,
              ContainerStockType: values.container_require_select,
              ContainerGrade: values.grade,
              ContainerApplyPlasticSheet: values.apply_layer_plastic_sheet,
              FirstPickupDate: values.first_pickup,
              ActualPickupDate: values.actual_pickup,
              DepotsId: values.depots?.DepotsId,
              InboundTransportGroupId: values.transport_InBound,
              InboundContainerGender: values.container_gender_Inbound,
              InboundVoyNo: values.voyIn,
              InboundQuantity: values.InboundQuantity,
              InboundETDGateOut: values.ETD_Gate_Out_Inbound,
              InboundETAGateIn: values.ETA_Gate_In_Inbound,
              InboundVoyNo_2: values.voyIn_2,
              InboundQuantity_2: values.InboundQuantity_2,
              InboundETDGateOut_2: values.ETD_Gate_Out_Inbound_2,
              InboundETAGateIn_2: values.ETA_Gate_In_Inbound_2,
              InboundVoyNo_3: values.voyIn_3,
              InboundQuantity_3: values.InboundQuantity_3,
              InboundETDGateOut_3: values.ETD_Gate_Out_Inbound_3,
              InboundETAGateIn_3: values.ETD_Gate_Out_Inbound_3,
              MtCntr: rowMTCACS.map((x) => ({
                MtCntrId: null,
                TruckRequest: x.Truck,
                Vender: x.Vender,
                NumberOfTrucks: x.NumberOfTrucks,
              })),
              StuffingPlan: rowStuffing.map((x) => ({
                StuffingPlanId: null,
                FactoryId: x.Factory?.FactoryId,
                PickupDate: moment(x.PUD).format("yyyy-MM-DD"),
                ReturnDate: moment(x.RD).format("yyyy-MM-DD"),
                Quantity: Number(x.RS) || 0,
              })),
              OutboundTransportGroupId: values.transport_OutBound,
              OutboundGateOutId: values.OutBoundGateOut?.LocationId || null,
              OutboundContainerGender: values.container_gender_OutBound,
              FirstLadenDate: values.first_Laden_Date,
              ActualLadenDate: values.actual_Laden_Date,
              OutboundVoyNo: values.voyOut,
              OutboundETDGateOut: values.ETD_Gate_Out_OutBound,
              OutboundETAGateIn: values.ETA_Gate_In_OutBound,
              OutboundQuantity: values.OutboundQuantity,
              OutboundVoyNo_2: values.voyOut_2,
              OutboundETDGateOut_2: values.ETD_Gate_Out_OutBound_2,
              OutboundETAGateIn_2: values.ETA_Gate_In_OutBound_2,
              OutboundQuantity_2: values.OutboundQuantity_2,
              OutboundVoyNo_3: values.voyOut_3,
              OutboundETDGateOut_3: values.ETD_Gate_Out_OutBound_3,
              OutboundETAGateIn_3: values.ETA_Gate_In_OutBound_3,
              OutboundQuantity_3: values.OutboundQuantity_3,
              Fumigation: values.fumigation,
              FumigationRemark: values.fumigation_remark,
              PhytoCert: values.phyto_cert,
              PhytoCertRemark: values.phyto_cert_remark,
              RemarkLogStatus: remarklog,
              FumigationInspectionStaionId: values.FumigationInspectionStaionId,
              PhytoCertInspectionStaionId: values.PhytoCertInspectionStaionId,
              FumigationPQNo: values.FumigationPQNo,
              RemarkType: remarkType,
              TerminalName: values.TerminalName?.TerminalName,
            };

            const postData = async () => {
              const res = await api.post(
                "api/saleorder/update/transportation",
                body
              );
              const data = await res.data;
              if (res?.meta?.status === true) {
                const MySwal = withReactContent(Swal);

                MySwal.fire({
                  icon: "success",
                  didOpen: () => {
                    MySwal.clickConfirm();
                  },
                }).then(() => {
                  return MySwal.fire(
                    "สำเร็จ!",
                    "เเก้ Sale Order สำเร็จ !",
                    "success"
                  ).then((result) => {
                    if (result.isConfirmed) {
                      // history.push("/CustomerSupport/SaleOrder");
                    }
                  });
                });
              }
            };
            setTimeout(() => {
              postData();
              // console.log(body)
              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            /* and other goodies */
          }) => (
            <form
              onSubmit={handleSubmit}
              style={{ margin: "20px", width: "100%" }}
            >
              <Grid container>
                <Grid item xs={12} md={12}>
                  <h6
                    // style={{ marginTop: "10px" }}
                    className="textcolordarkblue"
                  >
                    Container Status
                  </h6>
                  <div>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <FormControl
                        sx={{ width: "50%", mr: "5px" }}
                        classes={{
                          root: !values.container_require_select
                            ? classes.customOutline
                            : null,
                        }}
                        required
                      >
                        <InputLabel>Container Stock</InputLabel>
                        <Select
                          name="container_require_select"
                          label="Container Stock"
                          value={values.container_require_select}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <MenuItem value="Stock">Stock</MenuItem>
                          <MenuItem value="Out Stock">Out Stock</MenuItem>
                        </Select>
                      </FormControl>
                      <TextField
                        name="grade"
                        label="Grade"
                        variant="outlined"
                        placeholder="Grade"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "25%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.grade}
                      />
                      {/* {errors.grade &&
                                    touched.grade &&
                                    errors.grade} */}
                      <FormControl sx={{ width: "50%", ml: "5px" }}>
                        <InputLabel>PLASTIC SHEET</InputLabel>
                        <Select
                          name="apply_layer_plastic_sheet"
                          label=" PLASTIC SHEET"
                          value={values.apply_layer_plastic_sheet}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <MenuItem value={true}>Yes</MenuItem>
                          <MenuItem value={false}>No</MenuItem>
                        </Select>
                      </FormControl>
                    </div>

                    <div style={{ display: "flex", marginTop: 10 }}>
                      <TextField
                        name="first_pickup"
                        label="1ST PICK UP"
                        variant="outlined"
                        placeholder="1ST PICK UP"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ readOnly: true }}
                        value={values.first_pickup ? moment(values.first_pickup).format("DD/MM/yyyy") : ''}
                        // defaultValue={values.first_pickup}
                      />
                      {/* {errors.first_pickup &&
                                    touched.first_pickup &&
                                    errors.first_pickup} */}
                      <DesktopDatePicker
                        inputFormat="dd/MM/yyyy"
                        name="actual_pickup"
                        label="Actual PICK UP"
                        value={values.actual_pickup}
                        onChange={(e) => {
                          const nformat = moment(e).format("YYYY-MM-DD");

                          //     // const mformat = moment(e, "DD/MM/YYYY").format(
                          //     //   "YYYY/MM/DD"
                          //     // );
                          //     // console.log(nformat);

                          setFieldValue("actual_pickup", nformat);
                          if (values.com) {
                            const laden_Date = SUM_FREETIME(
                              values.CountingType + "_RL",
                              values.etd_pol,
                              values.closing_date,
                              values.first_pickup,
                              nformat,
                              values.det,
                              values.dem,
                              values.com
                            );
                            if (laden_Date) {
                              setFieldValue("first_Laden_Date", laden_Date);
                            }
                          } else {
                          }

                          //     // setClosingdate(mformat);
                          //     // if (
                          //     //   values.com != "" &&
                          //     //   values.det == "" &&
                          //     //   values.dem == "" &&
                          //     //   values.choice_com_calculate == "2"
                          //     // ) {
                          //     //   let date_now = +new Date(nformat);

                          //     //   setFieldValue(
                          //     //     "first_pickup",
                          //     //     moment(
                          //     //       new Date(
                          //     //         date_now + values.com * 24 * 60 * 60 * 1000
                          //     //       )
                          //     //     ).format("YYYY-MM-DD")
                          //     //   );
                          // }
                        }}
                        renderInput={(params) => (
                          <TextField
                            style={{
                              width: "50%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            {...params}
                            // classes={{
                            //     root:
                            //         !values.actual_pickup
                            //             ? classes.customOutline
                            //             : null,
                            // }}
                            // required
                          />
                        )}
                      />
                      {values.actual_pickup && values.first_pickup ? (
                        <TextField
                          label="diff"
                          sx={{
                            marginRight: "5px",
                            "& .MuiInputBase-input": {
                              color:
                                Math.round(
                                  // Math.abs(
                                  (new Date(values.actual_pickup) -
                                    new Date(values.first_pickup)) /
                                    // )
                                    1000 /
                                    60 /
                                    60 /
                                    24
                                ) >= 0
                                  ? "#000"
                                  : "red",
                            },
                          }}
                          value={Math.round(
                            // Math.abs(
                            (new Date(values.actual_pickup) -
                              new Date(values.first_pickup)) /
                              // )
                              1000 /
                              60 /
                              60 /
                              24
                          )}
                        />
                      ) : (
                        ""
                      )}
                      {/* {values.container_require == 0 ? ( */}

                      <Autocomplete
                        name="depots"
                        options={depotsData}
                        getOptionLabel={(option) => option?.DepotsName}
                        // classes={{
                        //   root:
                        //     !formik.values.serviceRoute.locationTo
                        //       ? classes.customOutline
                        //       : null,
                        // }}

                        onChange={(x, y) => {
                          setFieldValue("depots", y);
                        }}
                        id="flat-demo"
                        // disabled={
                        //   values.liners ? true : false
                        // }
                        value={values.depots}
                        sx={{ width: "50%", ml: "5px" }}
                        renderInput={(params) => (
                          <TextField {...params} label="DEPOTS" />
                        )}
                      />
                    </div>
                    {/* ซ่อน Inbound block เมื่อเป็นงาน One-Way / Export (เริ่มที่โรงงาน ไม่มีขาเข้า) */}
                    {!(values.TripType === "One-Way" && values.TripDirection === "Export") && (
                    <>
                    <h6
                      style={{ marginTop: "10px" }}
                      className="textcolordarkblue"
                    >
                      Transportation Inbound
                    </h6>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <FormControl
                        sx={{ width: "30%", mr: "5px" }}
                        classes={{
                          root: !values.transport_InBound
                            ? classes.customOutline
                            : null,
                        }}
                        required
                      >
                        <InputLabel>Transport</InputLabel>
                        <Select
                          name="transport_InBound"
                          label="Transport"
                          value={values.transport_InBound}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            setFieldValue("transport_InBound", e.target.value);
                            setFieldValue("voyIn", "");
                            setFieldValue("ETA_Gate_In_Inbound", null);
                            setFieldValue("ETD_Gate_Out_Inbound", null);
                            // setFieldValue("InBoundGateOut", null);

                            // setChooseText(e.target.value);
                          }}
                          onBlur={handleBlur}
                        >
                          <MenuItem value="" disabled>
                            <em>เลือก ประเภทการขนส่ง </em>
                          </MenuItem>
                          {groupData.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option?.GroupId}>
                                {option?.GroupName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                      <Autocomplete
                        options={locationData}
                        getOptionLabel={(option) => option?.LocationName}
                        classes={{
                          root: !values.InBoundGateOut
                            ? classes.customOutline
                            : null,
                        }}
                        required
                        onChange={(x, y) => {
                          setFieldValue("InBoundGateOut", y);
                        }}
                        value={values.InBoundGateOut}
                        id="flat-demo"
                        sx={{ width: "40%", mr: "5px" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Gate Out" />
                        )}
                      />
                      <FormControl
                        sx={{ width: "30%", mr: "5px" }}
                        classes={{
                          root: !values.fumigation
                            ? classes.container_gender_Inbound
                            : null,
                        }}
                        required
                      >
                        <InputLabel>Container Gender</InputLabel>
                        <Select
                          name="container_gender_Inbound"
                          label="Container Gender"
                          value={values.container_gender_Inbound}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <MenuItem value="Empty">Empty</MenuItem>
                          <MenuItem value="Laden">Laden</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <TextField
                        label="Voy IN"
                        name="voyIn"
                        value={values.voyIn}
                        InputLabelProps={{ shrink: true }}
                        onBlur={handleBlur}
                        sx={{
                          width: "40%",
                          marginRight: "5px",
                          "& .MuiInputBase-input": {},
                        }}
                      />
                      {values.first_pickup &&
                        values.transport_InBound &&
                        values.InBoundGateOut && (
                          <Button
                            variant="contained"
                            onClick={() => {
                              setSelectedDialog(1);
                              setOpenVoyIn(true);
                              const body = {
                                FirstPickupDate: values.first_pickup,
                                InboundTransportGroupId:
                                  values.transport_InBound,
                                InboundGateOutId:
                                  values.InBoundGateOut.LocationId,
                                OutboundGateOutId:
                                  values.OutBoundGateOut.LocationId,
                                ClosingDate: values.closing_date,
                                ClosingTime: values.closing_time,
                                ContainerTypeId: values.volume_container,
                                Quantity: values.volume_quantity,
                                CommodityId: values.commodity,
                              };
                              const getVoyIn = async () => {
                                const res = await api.post(
                                  `api/saleorder/voy/inbound`,
                                  body
                                );
                                const data = await res.data;
                                setVoyIn(data);
                              };

                              getVoyIn();
                            }}
                          >
                            search
                          </Button>
                        )}

                      <DesktopDatePicker
                        inputFormat="dd/MM/yyyy"
                        name="ETD_Gate_Out_Inbound"
                        label="ETD Gate Out"
                        value={values.ETD_Gate_Out_Inbound}
                        onChange={(e) => {
                          const nformat = moment(e).format("yyyy-MM-DD");
                          setFieldValue("ETD_Gate_Out_Inbound", nformat);
                        }}
                        renderInput={(params) => (
                          <TextField
                            style={{
                              width: "30%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            {...params}
                          />
                        )}
                      />
                      <DesktopDatePicker
                        inputFormat="dd/MM/yyyy"
                        name="ETA_Gate_In_Inbound"
                        label="ETA Gate IN"
                        value={values.ETA_Gate_In_Inbound}
                        onChange={(e) => {
                          const nformat = moment(e).format("yyyy-MM-DD");
                          setFieldValue("ETA_Gate_In_Inbound", nformat);
                        }}
                        renderInput={(params) => (
                          <TextField
                            style={{
                              width: "30%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            {...params}
                          />
                        )}
                      />

                      {values.transport_InBound === "G002" && (
                        <TextField
                          name="InboundQuantity"
                          label="InboundQuantity"
                          variant="outlined"
                          placeholder="Quantity"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          style={{
                            width: "20%",
                            marginRight: 5,
                            marginLeft: 5,
                          }}
                          InputLabelProps={{ shrink: true }}
                          value={values.InboundQuantity || ""}
                        />
                      )}
                      {values.voyIn && (
                        <Button
                          color="error"
                          variant="contained"
                          onClick={() => {
                            setFieldValue("voyIn", "");
                            setFieldValue("ETA_Gate_In_Inbound", null);
                            setFieldValue("ETD_Gate_Out_Inbound", null);
                            setFieldValue("InboundQuantity", "");
                          }}
                        >
                          clear
                        </Button>
                      )}
                    </div>
                    {values.transport_InBound === "G002" && (
                      <>
                        <div style={{ display: "flex", marginTop: 10 }}>
                          <TextField
                            label="Voy IN"
                            name="voyIn_2"
                            value={values.voyIn_2}
                            InputLabelProps={{ shrink: true }}
                            onBlur={handleBlur}
                            sx={{
                              width: "40%",
                              marginRight: "5px",
                              "& .MuiInputBase-input": {},
                            }}
                          />
                          {values.first_pickup &&
                            values.transport_InBound &&
                            values.InBoundGateOut && (
                              <Button
                                variant="contained"
                                onClick={() => {
                                  setSelectedDialog(2);
                                  setOpenVoyIn(true);
                                  const body = {
                                    FirstPickupDate: values.first_pickup,
                                    InboundTransportGroupId:
                                      values.transport_InBound,
                                    InboundGateOutId:
                                      values.InBoundGateOut.LocationId,
                                    OutboundGateOutId:
                                      values.OutBoundGateOut.LocationId,
                                    ClosingDate: values.closing_date,
                                    ClosingTime: values.closing_time,
                                    ContainerTypeId: values.volume_container,
                                    Quantity: values.volume_quantity,
                                    CommodityId: values.commodity,
                                  };
                                  const getVoyIn = async () => {
                                    const res = await api.post(
                                      `api/saleorder/voy/inbound`,
                                      body
                                    );
                                    const data = await res.data;
                                    setVoyIn(data);
                                  };
                                  getVoyIn();
                                }}
                              >
                                search
                              </Button>
                            )}

                          <DesktopDatePicker
                            inputFormat="dd/MM/yyyy"
                            name="ETD_Gate_Out_Inbound_2"
                            label="ETD Gate Out"
                            value={values.ETD_Gate_Out_Inbound_2}
                            onChange={(e) => {
                              const nformat = moment(e).format("yyyy-MM-DD");
                              setFieldValue("ETD_Gate_Out_Inbound_2", nformat);
                            }}
                            renderInput={(params) => (
                              <TextField
                                style={{
                                  width: "30%",
                                  marginRight: 5,
                                  marginLeft: 5,
                                }}
                                {...params}
                              />
                            )}
                          />
                          <DesktopDatePicker
                            inputFormat="dd/MM/yyyy"
                            name="ETA_Gate_In_Inbound_2"
                            label="ETA Gate IN"
                            value={values.ETA_Gate_In_Inbound_2}
                            onChange={(e) => {
                              const nformat = moment(e).format("yyyy-MM-DD");
                              setFieldValue("ETA_Gate_In_Inbound_2", nformat);
                            }}
                            renderInput={(params) => (
                              <TextField
                                style={{
                                  width: "30%",
                                  marginRight: 5,
                                  marginLeft: 5,
                                }}
                                {...params}
                              />
                            )}
                          />
                          <TextField
                            name="InboundQuantity_2"
                            label="InboundQuantity"
                            variant="outlined"
                            placeholder="Quantity"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "20%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.InboundQuantity_2 || ""}
                          />
                          {values.voyIn_2 && (
                            <Button
                              color="error"
                              variant="contained"
                              onClick={() => {
                                setFieldValue("voyIn_2", "");
                                setFieldValue("ETA_Gate_In_Inbound_2", null);
                                setFieldValue("ETD_Gate_Out_Inbound_2", null);
                                setFieldValue("InboundQuantity_2", "");
                              }}
                            >
                              clear
                            </Button>
                          )}
                        </div>
                        <div style={{ display: "flex", marginTop: 10 }}>
                          <TextField
                            label="Voy IN"
                            name="voyIn_3"
                            value={values.voyIn_3}
                            InputLabelProps={{ shrink: true }}
                            onBlur={handleBlur}
                            sx={{
                              width: "40%",
                              marginRight: "5px",
                              "& .MuiInputBase-input": {},
                            }}
                          />
                          {values.first_pickup &&
                            values.transport_InBound &&
                            values.InBoundGateOut && (
                              <Button
                                variant="contained"
                                onClick={() => {
                                  setSelectedDialog(3);
                                  setOpenVoyIn(true);
                                  const body = {
                                    FirstPickupDate: values.first_pickup,
                                    InboundTransportGroupId:
                                      values.transport_InBound,
                                    InboundGateOutId:
                                      values.InBoundGateOut.LocationId,
                                    OutboundGateOutId:
                                      values.OutBoundGateOut.LocationId,
                                    ClosingDate: values.closing_date,
                                    ClosingTime: values.closing_time,
                                    ContainerTypeId: values.volume_container,
                                    Quantity: values.volume_quantity,
                                    CommodityId: values.commodity,
                                  };
                                  const getVoyIn = async () => {
                                    const res = await api.post(
                                      `api/saleorder/voy/inbound`,
                                      body
                                    );
                                    const data = await res.data;
                                    setVoyIn(data);
                                  };
                                  getVoyIn();
                                }}
                              >
                                search
                              </Button>
                            )}

                          <DesktopDatePicker
                            inputFormat="dd/MM/yyyy"
                            name="ETD_Gate_Out_Inbound_3"
                            label="ETD Gate Out"
                            value={values.ETD_Gate_Out_Inbound_3}
                            onChange={(e) => {
                              const nformat = moment(e).format("yyyy-MM-DD");
                              setFieldValue("ETD_Gate_Out_Inbound_3", nformat);
                            }}
                            renderInput={(params) => (
                              <TextField
                                style={{
                                  width: "30%",
                                  marginRight: 5,
                                  marginLeft: 5,
                                }}
                                {...params}
                              />
                            )}
                          />
                          <DesktopDatePicker
                            inputFormat="dd/MM/yyyy"
                            name="ETA_Gate_In_Inbound_3"
                            label="ETA Gate IN"
                            value={values.ETA_Gate_In_Inbound_3}
                            onChange={(e) => {
                              const nformat = moment(e).format("yyyy-MM-DD");
                              setFieldValue("ETA_Gate_In_Inbound_3", nformat);
                            }}
                            renderInput={(params) => (
                              <TextField
                                style={{
                                  width: "30%",
                                  marginRight: 5,
                                  marginLeft: 5,
                                }}
                                {...params}
                              />
                            )}
                          />
                          <TextField
                            name="InboundQuantity_3"
                            label="InboundQuantity"
                            variant="outlined"
                            placeholder="Quantity"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "20%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.InboundQuantity_3 || ""}
                          />
                          {values.voyIn_3 && (
                            <Button
                              color="error"
                              variant="contained"
                              onClick={() => {
                                setFieldValue("voyIn_3", "");
                                setFieldValue("ETA_Gate_In_Inbound_3", null);
                                setFieldValue("ETD_Gate_Out_Inbound_3", null);
                                setFieldValue("InboundQuantity_3", "");
                              }}
                            >
                              clear
                            </Button>
                          )}
                        </div>
                      </>
                    )}
                    <Dialog
                      fullWidth
                      maxWidth="lg"
                      open={openVoyIn}
                      onClose={() => setOpenVoyIn(false)}
                    >
                      <DialogTitle>Transportation Inbound</DialogTitle>
                      <DialogContent>
                        {/* <DialogContentText>
                              To subscribe to this website, please enter your email address here. We
                              will send updates occasionally.
                            </DialogContentText> */}
                        <Box sx={{ height: 400, width: "100%" }}>
                          <DataGrid
                            getRowId={(r) => r.VoyageScheduleId}
                            rows={voyIn?.map((x) => ({
                              ...x,
                              NewETDLocationFrom: moment(
                                x?.ETDLocationFrom
                              ).format("DD/MM/yyyy h:mm"),
                              NewETALocationTo: moment(x?.ETALocationTo).format(
                                "DD/MM/yyyy  h:mm"
                              ),
                            }))}
                            columns={[
                              {
                                field: "VoyNo",
                                headerName: "Voy No",
                                width: 200,
                                editable: true,
                              },
                              {
                                field: "NewETDLocationFrom",
                                headerName: "ETD",
                                width: 200,
                                editable: true,
                              },
                              {
                                field: "NewETALocationTo",
                                headerName: "ETA",
                                width: 200,
                                editable: true,
                              },
                              {
                                field: "Remark",
                                headerName: "Remark",
                                width: 400,
                                editable: true,
                              },
                              {
                                headerName: "Action",
                                width: 110,
                                editable: true,
                                renderCell: (params) => {
                                  return (
                                    <>
                                      <Button
                                        variant="contained"
                                        style={{
                                          textTransform: "none",
                                          backgroundColor: "#007BFF",
                                        }}
                                        onClick={() => {
                                          if (selectDialog === 1) {
                                            setFieldValue(
                                              "voyIn",
                                              params.row.VoyNo
                                            );
                                            setFieldValue(
                                              "ETA_Gate_In_Inbound",
                                              moment(
                                                params.row.ETALocationTo
                                              ).format("yyyy-MM-DD")
                                            );
                                            setFieldValue(
                                              "ETD_Gate_Out_Inbound",
                                              moment(
                                                params.row.ETDLocationFrom
                                              ).format("yyyy-MM-DD")
                                            );
                                            setOpenVoyIn(false);
                                            setSelectedDialog();
                                          } else if (selectDialog === 2) {
                                            setFieldValue(
                                              "voyIn_2",
                                              params.row.VoyNo
                                            );
                                            setFieldValue(
                                              "ETA_Gate_In_Inbound_2",
                                              moment(
                                                params.row.ETALocationTo
                                              ).format("yyyy-MM-DD")
                                            );
                                            setFieldValue(
                                              "ETD_Gate_Out_Inbound_2",
                                              moment(
                                                params.row.ETDLocationFrom
                                              ).format("yyyy-MM-DD")
                                            );
                                            setOpenVoyIn(false);
                                            setSelectedDialog();
                                          } else if (selectDialog === 3) {
                                            setFieldValue(
                                              "voyIn_3",
                                              params.row.VoyNo
                                            );
                                            setFieldValue(
                                              "ETA_Gate_In_Inbound_3",
                                              moment(
                                                params.row.ETALocationTo
                                              ).format("yyyy-MM-DD")
                                            );
                                            setFieldValue(
                                              "ETD_Gate_Out_Inbound_3",
                                              moment(
                                                params.row.ETDLocationFrom
                                              ).format("yyyy-MM-DD")
                                            );
                                            setOpenVoyIn(false);
                                            setSelectedDialog();
                                          }
                                        }}
                                      >
                                        select
                                      </Button>
                                    </>
                                  );
                                },
                              },
                            ]}
                            disableSelectionOnClick
                            hideFooter={true}
                            disableColumnFilter
                            disableColumnMenu
                            experimentalFeatures={{ newEditingApi: true }}
                          />
                        </Box>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={() => {
                            setOpenVoyIn(false);
                            setSelectedDialog();
                          }}
                        >
                          Cancel
                        </Button>
                      </DialogActions>
                    </Dialog>
                    <h6
                      style={{ marginTop: "10px" }}
                      className="textcolordarkblue"
                    >
                      Truck Plan
                    </h6>
                    <div style={{ marginTop: 10 }}>
                      <TableContainer>
                        <Table>
                          <TableHead sx={{ backgroundColor: "#e7e7e7" }}>
                            <TableRow>
                              <TableCell sx={{ width: "20%" }}>
                                Request Truck
                              </TableCell>
                              <TableCell sx={{ width: "40%" }}>
                                Vender
                              </TableCell>
                              <TableCell sx={{ width: "20%" }}>
                                Number of Trucks
                              </TableCell>
                              <TableCell sx={{ width: "20%" }}>
                                Action
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell>
                                {/* <TextField
                                                                        size="small"
                                                                        label="add Truck"
                                                                        value={addTruck}
                                                                        onChange={e => setAddTruck(e.target.value)}
                                                                        sx={{
                                                                            width: '100%',
                                                                            marginRight: '5px', "& .MuiInputBase-input": {

                                                                            }
                                                                        }}
                                                                    /> */}
                                <FormControl
                                  size="small"
                                  sx={{ width: "100%", mr: "5px" }}
                                >
                                  <InputLabel>Request</InputLabel>
                                  <Select
                                    name="container_gender_Inbound"
                                    label="Request"
                                    value={addTruck}
                                    // InputLabelProps={{ shrink: true }}
                                    onChange={(e) =>
                                      setAddTruck(e.target.value)
                                    }
                                  >
                                    <MenuItem value={true}>Yes</MenuItem>
                                    <MenuItem value={false}>No</MenuItem>
                                  </Select>
                                </FormControl>
                              </TableCell>
                              <TableCell>
                                <FormControl
                                  size="small"
                                  sx={{ width: "100%", mr: "5px" }}
                                >
                                  <InputLabel>Vender</InputLabel>
                                  <Select
                                    label="Vender"
                                    value={addVender}
                                    onChange={(e) =>
                                      setAddVender(e.target.value)
                                    }
                                  >
                                    {venderData
                                      ?.filter(
                                        (y) =>
                                          rowMTCACS?.find(
                                            (z) => z?.Vender === y?.VenderName
                                          )?.Vender !== y?.VenderName
                                      )
                                      ?.map((x, i) => (
                                        <MenuItem key={i} value={x?.VenderName}>
                                          {x?.VenderName}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormControl>
                              </TableCell>
                              <TableCell>
                                <TextField
                                  label="Trucks"
                                  name="number"
                                  value={numberOfTrucks}
                                  onChange={(e) =>
                                    setNumberOfTrucks(e.target.value)
                                  }
                                  size="small"
                                  sx={{
                                    width: "100%",
                                    marginRight: "5px",
                                    "& .MuiInputBase-input": {},
                                  }}
                                />
                              </TableCell>
                              <TableCell>
                                <Button
                                  variant="contained"
                                  size="small"
                                  disabled={
                                    addTruck && addVender ? false : true
                                  }
                                  sx={{
                                    width: "100%",
                                    backgroundColor: "#80c340",
                                    marginBottom: "10px",
                                    "&:hover": {
                                      backgroundColor: "#80c340",
                                    },
                                  }}
                                  onClick={() => {
                                    setRowMTCACS([
                                      ...rowMTCACS,
                                      {
                                        id: rowMTCACS.slice(-1)[0]?.id
                                          ? rowMTCACS.slice(-1)[0]?.id + 1
                                          : 1,
                                        Truck: addTruck,
                                        Vender: addVender,
                                        NumberOfTrucks: numberOfTrucks,
                                      },
                                    ]);
                                    setAddTruck("");
                                    setAddVender("");
                                    setNumberOfTrucks("");
                                  }}
                                >
                                  Add Row
                                </Button>
                              </TableCell>
                            </TableRow>
                            {rowMTCACS?.map((x, i) => (
                              <TableRow>
                                <TableCell>
                                  {" "}
                                  {isEdit.status && isEdit.id === x?.id ? (
                                    <FormControl
                                      size="small"
                                      sx={{ width: "100%", mr: "5px" }}
                                    >
                                      <InputLabel>Request</InputLabel>
                                      <Select
                                        name="container_gender_Inbound"
                                        label="Request"
                                        value={editTruck}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) =>
                                          setEditTruck(e.target.value)
                                        }
                                      >
                                        <MenuItem value={true}>Yes</MenuItem>
                                        <MenuItem value={false}>No</MenuItem>
                                      </Select>
                                    </FormControl>
                                  ) : (
                                    <FormControl
                                      size="small"
                                      sx={{ width: "100%", mr: "5px" }}
                                    >
                                      <InputLabel>Request</InputLabel>
                                      <Select
                                        disabled
                                        name="container_gender_Inbound"
                                        label="Request"
                                        value={x?.Truck}
                                        InputLabelProps={{ shrink: true }}
                                        // onChange={e => setAddTruck(e.target.value)}
                                      >
                                        <MenuItem value={true}>Yes</MenuItem>
                                        <MenuItem value={false}>No</MenuItem>
                                      </Select>
                                    </FormControl>
                                  )}
                                </TableCell>
                                <TableCell>
                                  {isEdit.status && isEdit.id === i + 1 ? (
                                    <FormControl
                                      size="small"
                                      sx={{ width: "100%", mr: "5px" }}
                                    >
                                      <InputLabel>Vender</InputLabel>
                                      <Select
                                        label="Vender"
                                        value={editVender}
                                        onChange={(e) =>
                                          setEditVender(e.target.value)
                                        }
                                      >
                                        {venderData
                                      ?.filter(
                                        (y) =>
                                          rowMTCACS?.find(
                                            (z) => z?.Vender === y?.VenderName
                                          )?.Vender !== y?.VenderName
                                      )
                                      ?.map((x, i) => (
                                          <MenuItem
                                            key={i}
                                            disabled={
                                              rowMTCACS?.find(
                                                (z) =>
                                                  z?.Vender === x?.VenderName
                                              )
                                                ? true
                                                : false
                                            }
                                            value={x?.VenderName}
                                          >
                                            {x?.VenderName}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  ) : (
                                    <TextField
                                      size="small"
                                      disabled
                                      label="Vender"
                                      value={x?.Vender}
                                      sx={{
                                        width: "100%",
                                        marginRight: "5px",
                                        "& .MuiInputBase-input": {},
                                      }}
                                    />
                                  )}
                                </TableCell>
                                <TableCell>
                                  {isEdit.status && isEdit.id === i + 1 ? (
                                    <TextField
                                      label="Trucks"
                                      name="NumberOfTrucks"
                                      value={editNumberOfTrucks}
                                      onChange={(e) =>
                                        setEditNumberOfTrucks(e.target.value)
                                      }
                                      size="small"
                                      sx={{
                                        width: "100%",
                                        marginRight: "5px",
                                        "& .MuiInputBase-input": {},
                                      }}
                                    />
                                  ) : (
                                    <TextField
                                      label="Trucks"
                                      name="NumberOfTrucks"
                                      disabled
                                      value={x?.NumberOfTrucks}
                                      size="small"
                                      sx={{
                                        width: "100%",
                                        marginRight: "5px",
                                        "& .MuiInputBase-input": {},
                                      }}
                                    />
                                  )}
                                </TableCell>
                                <TableCell sx={{ display: "flex" }}>
                                  {isEdit.status && isEdit.id === i + 1 ? (
                                    <Button
                                      variant="contained"
                                      size="small"
                                      sx={{
                                        width: "100%",
                                        backgroundColor: "#80c340",
                                        marginRight: "10px",
                                        marginBottom: "10px",
                                        "&:hover": {
                                          backgroundColor: "#80c340",
                                        },
                                      }}
                                      onClick={() => {
                                        const data = rowMTCACS?.map((n) => {
                                          n.Vender =
                                            n?.id === x?.id
                                              ? editVender
                                              : n?.Vender;
                                          n.Truck =
                                            n?.id === x?.id
                                              ? editTruck
                                              : n?.Truck;
                                          n.NumberOfTrucks =
                                            n?.id === x?.id
                                              ? editNumberOfTrucks
                                              : n?.NumberOfTrucks;
                                          return n;
                                        });
                                        setRowMTCACS([...data]);
                                        setIsEdit({ status: false, id: null });
                                      }}
                                    >
                                      save
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="contained"
                                      size="small"
                                      sx={{
                                        width: "100%",
                                        backgroundColor: "#80c340",
                                        marginRight: "10px",
                                        marginBottom: "10px",
                                        "&:hover": {
                                          backgroundColor: "#80c340",
                                        },
                                      }}
                                      onClick={() => {
                                        setEditTruck(x?.Truck);
                                        setEditVender(x?.Vender);
                                        setEditNumberOfTrucks(
                                          x?.NumberOfTrucks
                                        );
                                        setIsEdit({ status: true, id: x?.id });
                                      }}
                                    >
                                      edit
                                    </Button>
                                  )}
                                  {/* <Button variant="contained"
                                                            size="small"
                                                            sx={{
                                                                width: '100%', backgroundColor: "#80c340", marginRight: '10px', '&:hover': {
                                                                    backgroundColor: '#80c340'
                                                                }
                                                            }}
                                                            onClick={() => {
                                                                setEditTruck(x?.Truck)
                                                                setEditVender(x?.Vender)
                                                                setIsEdit({ status: true, id: x?.id })
                                                            }}
                                                        >edit</Button> */}
                                  <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                      width: "100%",
                                      backgroundColor: "red",
                                      marginBottom: "10px",
                                      "&:hover": {
                                        backgroundColor: "red",
                                      },
                                    }}
                                    onClick={() => {
                                      const data = rowMTCACS?.filter(
                                        (y) => y?.id !== x?.id
                                      );
                                      setRowMTCACS(data);
                                      setIsEdit({ status: false, id: null });
                                    }}
                                  >
                                    delete
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                    <h6
                      style={{ marginTop: "10px" }}
                      className="textcolordarkblue"
                    >
                      Stuffing Plan
                    </h6>
                    <div style={{ marginTop: 10 }}>
                      <TableContainer>
                        <Table>
                          <TableHead sx={{ backgroundColor: "#e7e7e7" }}>
                            <TableRow>
                              <TableCell sx={{ width: "20%" }}>
                                Pick-up Date
                              </TableCell>
                              <TableCell sx={{ width: "20%" }}>
                                Factory
                              </TableCell>
                              <TableCell sx={{ width: "20%" }}>
                                Return Date
                              </TableCell>
                              <TableCell sx={{ width: "20%" }}>
                                Quantity
                              </TableCell>
                              <TableCell sx={{ width: "20%" }}>
                                Action
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell>
                                <DesktopDatePicker
                                  inputFormat="dd/MM/yyyy"
                                  // name="actual_pickup"
                                  label="Pick-up Date"
                                  value={addPUD}
                                  onChange={(e) => setAddPUD(e)}
                                  renderInput={(params) => (
                                    <TextField
                                      size="small"
                                      style={{
                                        width: "100%",
                                        marginRight: 5,
                                      }}
                                      {...params}
                                    />
                                  )}
                                />
                              </TableCell>
                              <TableCell>
                                <Autocomplete
                                  size="small"
                                  options={factoryData}
                                  getOptionLabel={(option) =>
                                    option?.FactoryName
                                  }
                                  id="flat-demo"
                                  sx={{ width: "100%", mr: "5px" }}
                                  value={addFactory}
                                  onChange={(event, newValue) => {
                                    setAddFactory(newValue);
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} label="Factory" />
                                  )}
                                />
                              </TableCell>
                              <TableCell>
                                <DesktopDatePicker
                                  inputFormat="dd/MM/yyyy"
                                  // name="actual_pickup"
                                  value={addRD}
                                  onChange={(e) => setAddRD(e)}
                                  label="Return Date"
                                  renderInput={(params) => (
                                    <TextField
                                      size="small"
                                      style={{
                                        width: "100%",
                                        marginRight: 5,
                                      }}
                                      {...params}
                                    />
                                  )}
                                />
                              </TableCell>
                              <TableCell>
                                <TextField
                                  label="Quantity"
                                  name=""
                                  value={addRS || ""}
                                  onChange={(e) => {
                                    setAddRs(e.target.value);
                                  }}
                                  size="small"
                                  sx={{
                                    width: "100%",
                                    marginRight: "5px",
                                    "& .MuiInputBase-input": {},
                                  }}
                                  type="tel"
                                />
                              </TableCell>
                              <TableCell>
                                <Button
                                  variant="contained"
                                  size="small"
                                  disabled={
                                    addFactory && addPUD && addRD && addRS
                                      ? false
                                      : true
                                  }
                                  sx={{
                                    width: "100%",
                                    backgroundColor: "#80c340",
                                    marginBottom: "10px",
                                    "&:hover": {
                                      backgroundColor: "#80c340",
                                    },
                                  }}
                                  onClick={() => {
                                    setRowStuffing([
                                      ...rowStuffing,
                                      {
                                        id: rowStuffing.slice(-1)[0]?.id
                                          ? rowStuffing.slice(-1)[0]?.id + 1
                                          : 1,
                                        Factory: addFactory,
                                        PUD: addPUD,
                                        RD: addRD,
                                        RS: addRS,
                                      },
                                    ]);
                                    setAddFactory(null);
                                    setAddPUD(null);
                                    setAddRD(null);
                                    setAddRs(null);
                                  }}
                                >
                                  Add Row
                                </Button>
                              </TableCell>
                            </TableRow>
                            {rowStuffing?.map((x, i) => (
                              <TableRow>
                                <TableCell>
                                  {" "}
                                  {isEditS.status && isEditS.id === x?.id ? (
                                    <DesktopDatePicker
                                      inputFormat="dd/MM/yyyy"
                                      // name="actual_pickup"
                                      value={editPUD}
                                      onChange={(e) => setEditPUD(e)}
                                      label="Pick-up Date"
                                      renderInput={(params) => (
                                        <TextField
                                          size="small"
                                          style={{
                                            width: "100%",
                                            marginRight: 5,
                                          }}
                                          {...params}
                                        />
                                      )}
                                    />
                                  ) : (
                                    <DesktopDatePicker
                                      inputFormat="dd/MM/yyyy"
                                      disabled
                                      // name="actual_pickup"
                                      value={x?.PUD}
                                      label="Pick-up Date"
                                      renderInput={(params) => (
                                        <TextField
                                          size="small"
                                          style={{
                                            width: "100%",
                                            marginRight: 5,
                                          }}
                                          {...params}
                                        />
                                      )}
                                    />
                                  )}
                                </TableCell>
                                <TableCell>
                                  {isEditS.status && isEditS.id === x?.id ? (
                                    <Autocomplete
                                      size="small"
                                      options={factoryData}
                                      getOptionLabel={(option) =>
                                        option?.FactoryName
                                      }
                                      id="flat-demo"
                                      sx={{ width: "100%", mr: "5px" }}
                                      value={editFactory}
                                      onChange={(event, newValue) => {
                                        setEditFactory(newValue);
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Factory"
                                        />
                                      )}
                                    />
                                  ) : (
                                    <Autocomplete
                                      size="small"
                                      options={factoryData}
                                      getOptionLabel={(option) =>
                                        option?.FactoryName
                                      }
                                      id="flat-demo"
                                      sx={{ width: "100%", mr: "5px" }}
                                      value={x?.Factory}
                                      disabled
                                      // onChange={(event, newValue) => {
                                      //   setEditFactory(newValue);
                                      // }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Factory"
                                        />
                                      )}
                                    />
                                  )}
                                </TableCell>
                                <TableCell>
                                  {isEditS.status && isEditS.id === x?.id ? (
                                    <DesktopDatePicker
                                      inputFormat="dd/MM/yyyy"
                                      // name="actual_pickup"
                                      value={editRD}
                                      onChange={(e) => setEditRD(e)}
                                      label="Return Date"
                                      renderInput={(params) => (
                                        <TextField
                                          size="small"
                                          style={{
                                            width: "100%",
                                            marginRight: 5,
                                          }}
                                          {...params}
                                        />
                                      )}
                                    />
                                  ) : (
                                    <DesktopDatePicker
                                      inputFormat="dd/MM/yyyy"
                                      disabled
                                      // name="actual_pickup"
                                      value={x?.RD}
                                      label="Return Date"
                                      renderInput={(params) => (
                                        <TextField
                                          size="small"
                                          style={{
                                            width: "100%",
                                            marginRight: 5,
                                          }}
                                          {...params}
                                        />
                                      )}
                                    />
                                  )}
                                </TableCell>
                                <TableCell>
                                  {isEditS.status && isEditS.id === x?.id ? (
                                    <TextField
                                      label="Quantity"
                                      name=""
                                      value={editRS || ""}
                                      onChange={(e) =>
                                        setEditRS(e.target.value)
                                      }
                                      size="small"
                                      type="tel"
                                      sx={{
                                        width: "100%",
                                        marginRight: "5px",
                                        "& .MuiInputBase-input": {},
                                      }}
                                    />
                                  ) : (
                                    <TextField
                                      label="Quantity"
                                      name=""
                                      disabled={true}
                                      value={x?.RS}
                                      size="small"
                                      type="tel"
                                      sx={{
                                        width: "100%",
                                        marginRight: "5px",
                                        "& .MuiInputBase-input": {},
                                      }}
                                    />
                                  )}
                                </TableCell>
                                <TableCell sx={{ display: "flex" }}>
                                  {isEditS.status && isEditS.id === x?.id ? (
                                    <Button
                                      variant="contained"
                                      size="small"
                                      sx={{
                                        width: "100%",
                                        backgroundColor: "#80c340",
                                        marginRight: "10px",
                                        marginBottom: "10px",
                                        "&:hover": {
                                          backgroundColor: "#80c340",
                                        },
                                      }}
                                      onClick={() => {
                                        const data = rowStuffing?.map((n) => {
                                          n.PUD =
                                            n?.id === x?.id ? editPUD : n?.PUD;
                                          n.RD =
                                            n?.id === x?.id ? editRD : n?.RD;
                                          n.Factory =
                                            n?.id === x?.id
                                              ? editFactory
                                              : n?.Factory;
                                          n.RS =
                                            n?.id === x?.id ? editRS : n?.RS;
                                          return n;
                                        });
                                        setRowStuffing([...data]);
                                        setIsEditS({ status: false, id: null });
                                      }}
                                    >
                                      save
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="contained"
                                      size="small"
                                      sx={{
                                        width: "100%",
                                        backgroundColor: "#80c340",
                                        marginRight: "10px",
                                        marginBottom: "10px",
                                        "&:hover": {
                                          backgroundColor: "#80c340",
                                        },
                                      }}
                                      onClick={() => {
                                        setEditFactory(x?.Factory);
                                        setEditPUD(x?.PUD);
                                        setEditRD(x?.RD);
                                        setEditRS(x?.RS);
                                        setIsEditS({ status: true, id: x?.id });
                                      }}
                                    >
                                      edit
                                    </Button>
                                  )}
                                  {/* <Button variant="contained"
                                                            size="small"
                                                            sx={{
                                                                width: '100%', backgroundColor: "#80c340", marginRight: '10px', '&:hover': {
                                                                    backgroundColor: '#80c340'
                                                                }
                                                            }}
                                                            onClick={() => {
                                                                setEditTruck(x?.Truck)
                                                                setEditVender(x?.Vender)
                                                                setIsEdit({ status: true, id: x?.id })
                                                            }}
                                                        >edit</Button> */}
                                  <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                      width: "100%",
                                      backgroundColor: "red",
                                      marginBottom: "10px",
                                      "&:hover": {
                                        backgroundColor: "red",
                                      },
                                    }}
                                    onClick={() => {
                                      const data = rowStuffing?.filter(
                                        (y) => y?.id !== x?.id
                                      );
                                      setRowStuffing(data);
                                    }}
                                  >
                                    delete
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                    </>
                    )}
                    {/* ซ่อน Outbound block เมื่อเป็นงาน One-Way / Import (จบที่โรงงาน ไม่มีขาออก) */}
                    {!(values.TripType === "One-Way" && values.TripDirection === "Import") && (
                    <>
                    <h6
                      style={{ marginTop: "10px" }}
                      className="textcolordarkblue"
                    >
                      Transportation Outbound
                    </h6>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <FormControl
                        sx={{ width: "30%", mr: "5px" }}
                        classes={{
                          root: !values.transport_OutBound
                            ? classes.customOutline
                            : null,
                        }}
                        required
                      >
                        <InputLabel>Transport</InputLabel>
                        <Select
                          name="transport_OutBound"
                          label="Transport"
                          value={values.transport_OutBound}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            setFieldValue("transport_OutBound", e.target.value);
                            // setFieldValue("OutBoundGateOut", null);
                            setFieldValue("voyOut", "");
                            setFieldValue("ETA_Gate_In_OutBound", null);
                            setFieldValue("ETD_Gate_Out_OutBound", null);
                            // setChooseText(e.target.value);
                          }}
                          onBlur={handleBlur}
                        >
                          <MenuItem value="" disabled>
                            <em>เลือก ประเภทการขนส่ง </em>
                          </MenuItem>
                          {groupData.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option?.GroupId}>
                                {option?.GroupName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                      <Autocomplete
                        options={locationData}
                        getOptionLabel={(option) => option?.LocationName}
                        onChange={(x, y) => {
                          setFieldValue("OutBoundGateOut", y);
                        }}
                        value={values.OutBoundGateOut}
                        classes={{
                          root: !values.OutBoundGateOut
                            ? classes.customOutline
                            : null,
                        }}
                        required
                        id="flat-demo"
                        sx={{ width: "40%", mr: "5px" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Gate Out" />
                        )}
                      />
                      <FormControl
                        sx={{ width: "30%", mr: "5px" }}
                        classes={{
                          root: !values.container_gender_OutBound
                            ? classes.customOutline
                            : null,
                        }}
                        required
                      >
                        <InputLabel>Container Gender</InputLabel>
                        <Select
                          name="container_gender_OutBound"
                          label="Container Gender"
                          value={values.container_gender_OutBound}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <MenuItem value="Empty">Empty</MenuItem>
                          <MenuItem value="Laden">Laden</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <TextField
                        label="Delivery"
                        variant="outlined"
                        placeholder="Delivery"
                        disabled
                        style={{ width: "100%"}}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ readOnly: true }}
                        // value={values.first_Laden_Date}
                        value={values.Delivery}

                        // defaultValue={values.first_pickup}
                      />
                    </div>
                    <h6
                      style={{ marginTop: "10px" }}
                      className="textcolordarkblue"
                    >
                      Return Laden Container
                    </h6>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <TextField
                        name="first_Laden_Date"
                        label="1ST Laden Date"
                        variant="outlined"
                        placeholder="1ST Laden Date"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "30%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ readOnly: true }}
                        // value={values.first_Laden_Date}
                        value={values.first_Laden_Date ? moment(values.first_Laden_Date).format(
                          "DD/MM/yyyy"
                        ) : ''}

                        // defaultValue={values.first_pickup}
                      />
                      {/* {errors.first_pickup &&
                                    touched.first_pickup &&
                                    errors.first_pickup} */}
                      <DesktopDatePicker
                        inputFormat="dd/MM/yyyy"
                        name="actual_Laden_Date"
                        label="Actual Date"
                        value={values.actual_Laden_Date}
                        onChange={(e) => {
                          const nformat = moment(e).format("YYYY-MM-DD");

                          // const mformat = moment(e, "DD/MM/YYYY").format(
                          //   "YYYY/MM/DD"
                          // );
                          // console.log(nformat);

                          setFieldValue("actual_Laden_Date", nformat);
                          if (values.com) {
                            const pickup_Date = SUM_FREETIME(
                              values.CountingType + "_PE",
                              values.etd_pol,
                              values.closing_date,
                              values.first_pickup,
                              nformat,
                              values.det,
                              values.dem,
                              values.com
                            );
                            if (pickup_Date) {
                              setFieldValue("first_pickup", pickup_Date);
                            }
                          } else {
                            const pickup_Date = SUM_FREETIME(
                              values.CountingType + "_DET",
                              values.etd_pol,
                              values.closing_date,
                              values.first_pickup,
                              nformat,
                              values.det,
                              values.dem,
                              values.com
                            );
                            if (pickup_Date) {
                              setFieldValue("first_pickup", pickup_Date);
                            }
                          }
                          // setClosingdate(mformat);
                          // if (
                          //   values.com != "" &&
                          //   values.det == "" &&
                          //   values.dem == "" &&
                          //   values.choice_com_calculate == "2"
                          // ) {
                          //   let date_now = +new Date(nformat);

                          //   setFieldValue(
                          //     "first_pickup",
                          //     moment(
                          //       new Date(
                          //         date_now + values.com * 24 * 60 * 60 * 1000
                          //       )
                          //     ).format("YYYY-MM-DD")
                          //   );
                          // }
                        }}
                        renderInput={(params) => (
                          <TextField
                            style={{
                              width: "30%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            // classes={{
                            //     root:
                            //         !values.actual_Laden_Date
                            //             ? classes.customOutline
                            //             : null,
                            // }}
                            // required
                            {...params}
                          />
                        )}
                      />
                      {values.actual_Laden_Date && values.first_Laden_Date ? (
                        <TextField
                          label="diff"
                          InputLabelProps={{ shrink: true }}
                          value={Math.round(
                            // Math.abs(
                            (new Date(values.actual_Laden_Date) -
                              new Date(values.first_Laden_Date)) /
                              // )
                              1000 /
                              60 /
                              60 /
                              24
                          )}
                          sx={{
                            marginRight: "5px",
                            "& .MuiInputBase-input": {
                              color:
                                Math.round(
                                  // Math.abs(
                                  (new Date(values.actual_Laden_Date) -
                                    new Date(values.first_Laden_Date)) /
                                    // )
                                    1000 /
                                    60 /
                                    60 /
                                    24
                                ) >= 0
                                  ? "#000"
                                  : "red",
                            },
                          }}
                        />
                      ) : (
                        ""
                      )}
                      {/* <FormControl style={{ width: "30%" }}>
                                                    <InputLabel>Terminal</InputLabel>
                                                    <Select
                                                        name="TerminalId"
                                                        label="Terminal"
                                                        value={values.TerminalId}
                                                        InputLabelProps={{ shrink: true }}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        MenuProps={{
                                                            style: {
                                                                maxHeight: 400,
                                                            },
                                                        }}
                                                    // disabled={values.inco_terms ? true : false}
                                                    >

                                                        {terminalData.map((option, index) => {
                                                            return (
                                                                <MenuItem
                                                                    key={index}
                                                                    value={option?.TerminalId}
                                                                >
                                                                    {option?.TerminalName}
                                                                </MenuItem>
                                                            );
                                                        })}
                                                    </Select>
                                                </FormControl> */}
                      <Autocomplete
                        name="TerminalName"
                        options={terminalData}
                        getOptionLabel={(option) => option?.TerminalName}
                        onChange={(x, y) => {
                          setFieldValue("TerminalName", y);
                        }}
                        id="flat-demo"
                        value={values.TerminalName}
                        sx={{ width: "30%", mr: "5px" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Terminal" />
                        )}
                      />
                    </div>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <TextField
                        label="Voy Out"
                        value={values.voyOut}
                        InputLabelProps={{ shrink: true }}
                        onBlur={handleBlur}
                        sx={{
                          width: "40%",
                          marginRight: "5px",
                          "& .MuiInputBase-input": {},
                        }}
                      />
                      {values.first_Laden_Date &&
                        values.transport_OutBound &&
                        values.OutBoundGateOut && (
                          <Button
                            variant="contained"
                            onClick={() => {
                              setOpenVoyOut(true);
                              setSelectedDialog(1);
                              const body = {
                                FirstLadenDate: values.first_Laden_Date,
                                OutboundTransportGroupId:
                                  values.transport_OutBound,
                                InboundGateOutId:
                                  values.InBoundGateOut.LocationId,
                                OutboundGateOutId:
                                  values.OutBoundGateOut.LocationId,
                                ClosingDate: values.closing_date,
                                ClosingTime: values.closing_time,
                                ContainerTypeId: values.volume_container,
                                Quantity: values.volume_quantity,
                                CommodityId: values.commodity,
                              };
                              const getVoyOut = async () => {
                                const res = await api.post(
                                  `api/saleorder/voy/outbound`,
                                  body
                                );
                                const data = await res.data;
                                if (res.meta.status === true) {
                                  setVoyOut(res.data);
                                }
                              };
                              getVoyOut();
                            }}
                          >
                            search
                          </Button>
                        )}

                      <DesktopDatePicker
                        inputFormat="dd/MM/yyyy"
                        // name="actual_pickup"
                        label="ETD Gate Out"
                        name="ETD_Gate_Out_OutBound"
                        value={values.ETD_Gate_Out_OutBound}
                        onChange={(e) => {
                          const nformat = moment(e).format("yyyy-MM-DD");
                          setFieldValue("ETD_Gate_Out_OutBound", nformat);
                        }}
                        renderInput={(params) => (
                          <TextField
                            style={{
                              width: "30%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            {...params}
                          />
                        )}
                      />
                      <DesktopDatePicker
                        inputFormat="dd/MM/yyyy"
                        // name="actual_pickup"
                        label="ETA Gate IN"
                        name="ETA_Gate_In_OutBound"
                        value={values.ETA_Gate_In_OutBound}
                        onChange={(e) => {
                          const nformat = moment(e).format("yyyy-MM-DD");
                          setFieldValue("ETA_Gate_In_OutBound", nformat);
                        }}
                        renderInput={(params) => (
                          <TextField
                            style={{
                              width: "30%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            {...params}
                          />
                        )}
                      />
                      {values.transport_OutBound === "G002" && (
                        <TextField
                          name="OutboundQuantity"
                          label="OutboundQuantity"
                          variant="outlined"
                          placeholder="Quantity"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          style={{
                            width: "20%",
                            marginRight: 5,
                            marginLeft: 5,
                          }}
                          InputLabelProps={{ shrink: true }}
                          value={values.OutboundQuantity || ""}
                        />
                      )}
                      {values.voyOut && (
                        <Button
                          color="error"
                          variant="contained"
                          onClick={() => {
                            setFieldValue("voyOut", "");
                            setFieldValue("ETA_Gate_In_OutBound", null);
                            setFieldValue("ETD_Gate_Out_OutBound", null);
                            setFieldValue("OutboundQuantity", "");
                          }}
                        >
                          clear
                        </Button>
                      )}
                    </div>
                    {values.transport_OutBound === "G002" && (
                      <>
                        <div style={{ display: "flex", marginTop: 10 }}>
                          <TextField
                            label="Voy Out"
                            name="voyOut_2"
                            value={values.voyOut_2}
                            InputLabelProps={{ shrink: true }}
                            onBlur={handleBlur}
                            sx={{
                              width: "40%",
                              marginRight: "5px",
                              "& .MuiInputBase-input": {},
                            }}
                          />
                          {values.first_Laden_Date &&
                            values.transport_OutBound &&
                            values.OutBoundGateOut && (
                              <Button
                                variant="contained"
                                onClick={() => {
                                  setOpenVoyOut(true);
                                  setSelectedDialog(2);
                                  const body = {
                                    FirstLadenDate: values.first_Laden_Date,
                                    OutboundTransportGroupId:
                                      values.transport_OutBound,
                                    InboundGateOutId:
                                      values.InBoundGateOut.LocationId,
                                    OutboundGateOutId:
                                      values.OutBoundGateOut.LocationId,
                                    ClosingDate: values.closing_date,
                                    ClosingTime: values.closing_time,
                                    ContainerTypeId: values.volume_container,
                                    Quantity: values.volume_quantity,
                                    CommodityId: values.commodity,
                                  };
                                  const getVoyOut = async () => {
                                    const res = await api.post(
                                      `api/saleorder/voy/outbound`,
                                      body
                                    );
                                    const data = await res.data;
                                    setVoyOut(data);
                                  };
                                  getVoyOut();
                                }}
                              >
                                search
                              </Button>
                            )}

                          <DesktopDatePicker
                            inputFormat="dd/MM/yyyy"
                            // name="actual_pickup"
                            label="ETD Gate Out"
                            name="ETD_Gate_Out_OutBound_2"
                            value={values.ETD_Gate_Out_OutBound_2}
                            onChange={(e) => {
                              const nformat = moment(e).format("yyyy-MM-DD");
                              setFieldValue("ETD_Gate_Out_OutBound_2", nformat);
                            }}
                            renderInput={(params) => (
                              <TextField
                                style={{
                                  width: "30%",
                                  marginRight: 5,
                                  marginLeft: 5,
                                }}
                                {...params}
                              />
                            )}
                          />
                          <DesktopDatePicker
                            inputFormat="dd/MM/yyyy"
                            // name="actual_pickup"
                            label="ETA Gate IN"
                            name="ETA_Gate_In_OutBound_2"
                            value={values.ETA_Gate_In_OutBound_2}
                            onChange={(e) => {
                              const nformat = moment(e).format("yyyy-MM-DD");
                              setFieldValue("ETA_Gate_In_OutBound_2", nformat);
                            }}
                            renderInput={(params) => (
                              <TextField
                                style={{
                                  width: "30%",
                                  marginRight: 5,
                                  marginLeft: 5,
                                }}
                                {...params}
                              />
                            )}
                          />
                          <TextField
                            name="OutboundQuantity_2"
                            label="OutboundQuantity"
                            variant="outlined"
                            placeholder="Quantity"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "20%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.OutboundQuantity_2 || ""}
                          />
                          {values.voyOut_2 && (
                            <Button
                              color="error"
                              variant="contained"
                              onClick={() => {
                                setFieldValue("voyOut_2", "");
                                setFieldValue("ETA_Gate_In_OutBound_2", null);
                                setFieldValue("ETD_Gate_Out_OutBound_2", null);
                                setFieldValue("OutboundQuantity_2", "");
                              }}
                            >
                              clear
                            </Button>
                          )}
                        </div>
                        <div style={{ display: "flex", marginTop: 10 }}>
                          <TextField
                            label="Voy Out"
                            name="voyOut_3"
                            value={values.voyOut_3}
                            InputLabelProps={{ shrink: true }}
                            onBlur={handleBlur}
                            sx={{
                              width: "40%",
                              marginRight: "5px",
                              "& .MuiInputBase-input": {},
                            }}
                          />
                          {values.first_Laden_Date &&
                            values.transport_OutBound &&
                            values.OutBoundGateOut && (
                              <Button
                                variant="contained"
                                onClick={() => {
                                  setOpenVoyOut(true);
                                  setSelectedDialog(3);
                                  const body = {
                                    FirstLadenDate: values.first_Laden_Date,
                                    OutboundTransportGroupId:
                                      values.transport_OutBound,
                                    InboundGateOutId:
                                      values.InBoundGateOut.LocationId,
                                    OutboundGateOutId:
                                      values.OutBoundGateOut.LocationId,
                                    ClosingDate: values.closing_date,
                                    ClosingTime: values.closing_time,
                                    ContainerTypeId: values.volume_container,
                                    Quantity: values.volume_quantity,
                                    CommodityId: values.commodity,
                                  };
                                  const getVoyOut = async () => {
                                    const res = await api.post(
                                      `api/saleorder/voy/outbound`,
                                      body
                                    );
                                    const data = await res.data;
                                    setVoyOut(data);
                                  };
                                  getVoyOut();
                                }}
                              >
                                search
                              </Button>
                            )}

                          <DesktopDatePicker
                            inputFormat="dd/MM/yyyy"
                            // name="actual_pickup"
                            label="ETD Gate Out"
                            name="ETD_Gate_Out_OutBound_3"
                            value={values.ETD_Gate_Out_OutBound_3}
                            onChange={(e) => {
                              const nformat = moment(e).format("yyyy-MM-DD");
                              setFieldValue("ETD_Gate_Out_OutBound_3", nformat);
                            }}
                            renderInput={(params) => (
                              <TextField
                                style={{
                                  width: "30%",
                                  marginRight: 5,
                                  marginLeft: 5,
                                }}
                                {...params}
                              />
                            )}
                          />
                          <DesktopDatePicker
                            inputFormat="dd/MM/yyyy"
                            // name="actual_pickup"
                            label="ETA Gate IN"
                            name="ETA_Gate_In_OutBound_3"
                            value={values.ETA_Gate_In_OutBound_3}
                            onChange={(e) => {
                              const nformat = moment(e).format("yyyy-MM-DD");
                              setFieldValue("ETA_Gate_In_OutBound_3", nformat);
                            }}
                            renderInput={(params) => (
                              <TextField
                                style={{
                                  width: "30%",
                                  marginRight: 5,
                                  marginLeft: 5,
                                }}
                                {...params}
                              />
                            )}
                          />
                          <TextField
                            name="OutboundQuantity_3"
                            label="OutboundQuantity"
                            variant="outlined"
                            placeholder="Quantity"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "20%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.OutboundQuantity_3 || ""}
                          />
                          {values.voyOut_3 && (
                            <Button
                              color="error"
                              variant="contained"
                              onClick={() => {
                                setFieldValue("voyOut_3", "");
                                setFieldValue("ETA_Gate_In_OutBound_3", null);
                                setFieldValue("ETD_Gate_Out_OutBound_3", null);
                                setFieldValue("OutboundQuantity_3", "");
                              }}
                            >
                              clear
                            </Button>
                          )}
                        </div>
                      </>
                    )}
                    <Dialog
                      fullWidth
                      maxWidth="lg"
                      open={openVoyOut}
                      onClose={() => setOpenVoyOut(false)}
                    >
                      <DialogTitle>Transportation Outbound</DialogTitle>
                      <DialogContent>
                        {/* <DialogContentText>
                              To subscribe to this website, please enter your email address here. We
                              will send updates occasionally.
                            </DialogContentText> */}
                        <Box sx={{ height: 400, width: "100%" }}>
                          <DataGrid
                            getRowId={(r) => r?.VoyageScheduleId}
                            rows={
                              voyOut?.map((x) => ({
                                ...x,
                                NewETDLocationFrom: moment(
                                  x?.ETDLocationFrom
                                ).format("DD/MM/yyyy h:mm"),
                                NewETALocationTo: moment(
                                  x?.ETALocationTo
                                ).format("DD/MM/yyyy  h:mm"),
                              })) || []
                            }
                            columns={[
                              {
                                field: "VoyNo",
                                headerName: "Voy No",
                                width: 200,
                                editable: true,
                              },
                              {
                                field: "NewETDLocationFrom",
                                headerName: "ETD",
                                width: 200,
                                editable: true,
                              },
                              {
                                field: "NewETALocationTo",
                                headerName: "ETA",
                                width: 200,
                                editable: true,
                              },
                              {
                                field: "Remark",
                                headerName: "Remark",
                                width: 400,
                                editable: true,
                              },
                              {
                                headerName: "Action",
                                width: 110,
                                editable: true,
                                renderCell: (params) => {
                                  return (
                                    <>
                                      <Button
                                        variant="contained"
                                        style={{
                                          textTransform: "none",
                                          backgroundColor: "#007BFF",
                                        }}
                                        onClick={() => {
                                          if (selectDialog === 1) {
                                            setFieldValue(
                                              "voyOut",
                                              params.row.VoyNo
                                            );
                                            setFieldValue(
                                              "ETA_Gate_In_OutBound",
                                              moment(
                                                params.row.ETALocationTo
                                              ).format("yyyy-MM-DD")
                                            );
                                            setFieldValue(
                                              "ETD_Gate_Out_OutBound",
                                              moment(
                                                params.row.ETDLocationFrom
                                              ).format("yyyy-MM-DD")
                                            );
                                            setOpenVoyOut(false);
                                            setSelectedDialog();
                                          } else if (selectDialog === 2) {
                                            setFieldValue(
                                              "voyOut_2",
                                              params.row.VoyNo
                                            );
                                            setFieldValue(
                                              "ETA_Gate_In_OutBound_2",
                                              moment(
                                                params.row.ETALocationTo
                                              ).format("yyyy-MM-DD")
                                            );
                                            setFieldValue(
                                              "ETD_Gate_Out_OutBound_2",
                                              moment(
                                                params.row.ETDLocationFrom
                                              ).format("yyyy-MM-DD")
                                            );
                                            setOpenVoyOut(false);
                                            setSelectedDialog();
                                          } else if (selectDialog === 3) {
                                            setFieldValue(
                                              "voyOut_3",
                                              params.row.VoyNo
                                            );
                                            setFieldValue(
                                              "ETA_Gate_In_OutBound_3",
                                              moment(
                                                params.row.ETALocationTo
                                              ).format("yyyy-MM-DD")
                                            );
                                            setFieldValue(
                                              "ETD_Gate_Out_OutBound_3",
                                              moment(
                                                params.row.ETDLocationFrom
                                              ).format("yyyy-MM-DD")
                                            );
                                            setOpenVoyOut(false);
                                            setSelectedDialog();
                                          }
                                        }}
                                      >
                                        select
                                      </Button>
                                    </>
                                  );
                                },
                              },
                            ]}
                            disableSelectionOnClick
                            hideFooter={true}
                            disableColumnFilter
                            disableColumnMenu
                            experimentalFeatures={{ newEditingApi: true }}
                          />
                        </Box>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={() => {
                            setOpenVoyOut(false);
                            setSelectedDialog();
                          }}
                        >
                          Cancel
                        </Button>
                      </DialogActions>
                    </Dialog>
                    </>
                    )}
                    <h6
                      style={{ marginTop: "10px" }}
                      className="textcolordarkblue"
                    >
                      Phyto
                    </h6>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <FormControl sx={{ width: "10%", mr: "5px" }}>
                        <InputLabel>PHYTO CERT</InputLabel>
                        <Select
                          name="phyto_cert"
                          label="PHYTO CERT"
                          value={values.phyto_cert}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <MenuItem value={true}>Yes</MenuItem>
                          <MenuItem value={false}>No</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl
                        sx={{ width: "25%", mr: "5px" }}
                        // classes={{
                        //   root:
                        //     !values.phyto_cert
                        //       ? classes.customOutline
                        //       : null,
                        // }}
                        //   required
                      >
                        <InputLabel>Inspection Station</InputLabel>
                        <Select
                          name="PhytoCertInspectionStaionId"
                          label="Inspection Station"
                          value={values.PhytoCertInspectionStaionId}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={values.phyto_cert !== true ? true : false}
                        >
                          {inspectionStationData?.map((item, i) => {
                            return (
                              <MenuItem value={item?.InspectionStationId}>
                                {item?.InspectionStationName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                      <TextField
                        name="phyto_cert_remark"
                        label="PHYTO CERT Remark"
                        variant="outlined"
                        disabled={values.phyto_cert !== true ? true : false}
                        placeholder="PHYTO CERT Remark"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={values.phyto_cert_remark}
                        sx={{ width: "65%" }}
                      />
                    </div>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <FormControl sx={{ width: "10%", mr: "5px" }}>
                        <InputLabel>FUMIGATION</InputLabel>
                        <Select
                          name="fumigation"
                          label="FUMIGATION"
                          value={values.fumigation}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <MenuItem value={true}>Yes</MenuItem>
                          <MenuItem value={false}>No</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl
                        sx={{ width: "25%", mr: "5px", marginRight: "5px" }}
                        // classes={{
                        //   root:
                        //     !values.phyto_cert
                        //       ? classes.customOutline
                        //       : null,
                        // }}
                        //   required
                      >
                        <InputLabel>Inspection Station</InputLabel>
                        <Select
                          name="FumigationInspectionStaionId"
                          label="Inspection Station"
                          value={values.FumigationInspectionStaionId}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={values.fumigation !== true ? true : false}
                        >
                          {inspectionStationData?.map((item, i) => {
                            return (
                              <MenuItem value={item?.InspectionStationId}>
                                {item?.InspectionStationName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                      <TextField
                        name="FumigationPQNo"
                        label="FumigationPQ No"
                        variant="outlined"
                        disabled={values.fumigation !== true ? true : false}
                        placeholder="FumigationPQ No"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={values.FumigationPQNo}
                        sx={{ width: "25%", mr: "5px" }}
                      />
                      <TextField
                        name="fumigation_remark"
                        label="FUMIGATION Remark"
                        variant="outlined"
                        disabled={values.fumigation !== true ? true : false}
                        placeholder="FUMIGATION Remark"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={values.fumigation_remark}
                        sx={{ width: "40%" }}
                      />
                    </div>
                    {/* {values.fumigation == "y" ? (
                              <div>
                                <div style={{ marginTop: 10 }}>
                                  <TextField
                                    name="fumigation_remark"
                                    label="FUMIGATION Remark"
                                    variant="outlined"
                                    placeholder="FUMIGATION Remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={values.fumigation_remark}
                                  />
                                  {errors.fumigation_remark &&
                                    touched.fumigation_remark &&
                                    errors.fumigation_remark}
                                </div>
                              </div>
                            ) : null}
                            {values.phyto_cert == "y" ? (
                              <div>
                                <div style={{ marginTop: 10 }}>
                                  <TextField
                                    name="phyto_cert_remark"
                                    label="PHYTO CERT Remark"
                                    variant="outlined"
                                    placeholder="PHYTO CERT Remark"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={values.phyto_cert_remark}
                                  />
                                  {errors.phyto_cert_remark &&
                                    touched.phyto_cert_remark &&
                                    errors.phyto_cert_remark}
                                </div>
                              </div>
                            ) : null} */}
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <Button
                        type="button"
                        variant="outlined"
                        style={{
                          color: "#80c340",
                          borderColor: "#80c340",
                          marginRight: "10px",
                        }}
                        onClick={history.goBack}
                      >
                        back
                      </Button>
                      <Button
                        variant="contained"
                        style={{
                          background: "#80c340",
                          borderColor: "#80c340",
                          marginRight: "10px",
                          color: "#FFF",
                        }}
                        onClick={() => setDiremark(true)}
                        // type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting && <CircularProgress size={22} />}
                        {!isSubmitting && "SAVE"}
                      </Button>
                      {transportationData?.SaleOrderStatus === 5 && (
                        <Button
                          variant="outlined"
                          style={{
                            color: "#84BD5A",
                            borderColor: "#84BD5A",
                            marginLeft: "5px",
                            width: "300px",
                          }}
                          onClick={async () => {
                            setLoadingBC(true);
                            await api
                              .get(
                                `api/report/booking-confirmation/download/pdf?SaleorderId=${id}`,
                                {
                                  responseType: "blob",
                                  timeout: 30000,
                                }
                              )
                              .then((blobFile) => {
                                const blobFileRes = new File(
                                  [blobFile?.data],
                                  "test.pdf",
                                  {
                                    type: mime.getType(".pdf"),
                                  }
                                );

                                // window.open(
                                //   URL.createObjectURL(blobFileRes, "test.csv"),
                                //   "_blank"
                                // );
                                saveAs(
                                  blobFileRes,
                                  "Report-booking-confirmation.pdf"
                                );
                                setLoadingBC(false);
                              });
                          }}
                        >
                          {loadingBC ? (
                            <CircularProgress size={22} />
                          ) : (
                            <Typography sx={{ color: "#8E8C8C" }}>
                              Print-booking-confirmation
                            </Typography>
                          )}
                        </Button>
                      )}
                    </div>
                  </div>
                </Grid>
              </Grid>
              <Dialog fullWidth="sm" open={diremark}>
                <DialogTitle>Remark</DialogTitle>
                <Box></Box>
                <DialogContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        autoFocus
                        name="RemarkLog"
                        label="Remark"
                        fullWidth
                        color="success"
                        variant="outlined"
                        onChange={(r) => setremarkLog(r.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel>Remark Option</InputLabel>
                        <Select
                          name="RemarkType"
                          label="Remark Type"
                          value={remarkType}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => setremarkType(e.target.value)}
                          MenuProps={{
                            style: {
                              maxHeight: 400,
                            },
                          }}
                          // disabled={values.inco_terms ? true : false}
                        >
                          {[
                            "Container Status",
                            "Inbound",
                            "Outbound",
                            "Truck Plan",
                            "Stuffing Plan",
                          ].map((option, index) => {
                            return (
                              <MenuItem key={index} value={option}>
                                {option}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <DialogActions
                    sx={{
                      marginTop: "24px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <form onSubmit={() => setDiremark(false)}>
                      <Button
                        type="button"
                        variant="outlined"
                        style={{
                          color: "#80c340",
                          borderColor: "#80c340",
                          marginRight: "10px",
                        }}
                        onClick={handleCloseremark}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        type="submit"
                        style={{
                          background: remarklog ? "#80c340" : "gray",
                          borderColor: "#80c340",
                          marginRight: "10px",
                          color: "#FFF",
                        }}
                        disabled={!remarklog ? true : false}
                      >
                        Submit
                      </Button>
                    </form>
                  </DialogActions>
                </DialogContent>
              </Dialog>
            </form>
          )}
        </Formik>
      ) : (
        "loading..."
      )}
    </Grid>
  );
}
